import {Injectable} from '@angular/core';
import {PubmaticBuyer, PubmaticEditRequestModel, PubmaticViewModel} from './pubmatic-state';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PubmaticClientService {

  constructor(private http: HttpClient) {
  }

  getById(pubmaticExternalId: string): Observable<PubmaticViewModel> {
    return this.http.get<PubmaticViewModel>(`${environment.apiSegments}/pubmatic/${pubmaticExternalId}`);
  }

  getBuyers(): Observable<PubmaticBuyer[]> {
    return this.http.get<PubmaticBuyer[]>(`${environment.apiSegments}/pubmatic/buyers`);
  }

  update(request: PubmaticEditRequestModel) {
    return this.http.patch<PubmaticViewModel>(`${environment.apiSegments}/pubmatic`, {
      price: request.config.price,
      pubmaticExternalId: request.pubmaticExternalId,
      segmentId: request.segmentId,
      accountId: request.accountId,
      changedBuyers: request.config.buyers
    });

  }
}
